import React, { useState, useRef, useEffect } from "react";
import PageLayout from "../../PageLayout/PageLayout";
import { Container, Row, Col } from "react-bootstrap";
import classes from "./PersnalInfo.module.css";
import Fonts from "../../../../../stories/assets/Fonts";
import Colors from "../../../../../stories/assets/Colors";
import { Button } from "../../../../../stories/Button/Button";
import { Radio } from "../../../../../stories/Radio/Radio";
import { Input } from "../../../../../stories/Input/Input";
import { DropDown } from "../../../../../stories/DropDown/DropDown";
import { TextArea } from "../../../../../stories/TextArea/TextArea";
import { LinkButtonWithIcon } from "../../../../../stories/LinkButtonWithIcon/LinkButtonWithIcon";
import { UploadedImageWithEditAndDelete } from "../../../../../stories/UploadedImageWithEditAndDelete/UploadedImageWithEditAndDelete";
import {
  certificate,
  addicon,
  addicongray,
  AddImageIcon,
  TrashIconGray,
  LinkIcon,
  PdfImg,
  AddIconBlue,
} from "../../../../../constant/imagePath";
import PersonalInfoMobile from "./PersonalInfoMobile";
import { isMobileViewHook } from "../../../../../CustomHooks/isMobileViewHook";
import EditPhotoModal from "../../../../../components/Modals/CoachFlow/OnBoarding/EditPhoto/EditPhoto";
import CertificateInformationCard from "../../../../../stories/CertificateInformationCard/CertificateInformationCard";
import { useDispatch, useSelector } from "react-redux";
import { setPersonalData } from "../../../../../store/Actions/authAction";

const PersnalInfoDesktop = () => {
  const dispatch = useDispatch();
  const getDataFromRedux = useSelector(
    (state) => state.onBoardingReducer?.personalInfo
  );

  const [gender, setGender] = useState(
    getDataFromRedux?.gender
      ? getDataFromRedux?.gender
      : { label: "Male", value: "Male" }
  );
  const [profile, setProfile] = useState();
  const [fullName, setFullName] = useState(
    getDataFromRedux?.fullName ? getDataFromRedux?.fullName : ""
  );
  const [phonenumber, setPhonenumber] = useState(
    getDataFromRedux?.phone ? getDataFromRedux?.phone : ""
  );
  const [dateOfBirth, setDateOfBirth] = useState(
    getDataFromRedux?.dob ? getDataFromRedux?.dob : ""
  );
  const [aboutYourself, setAboutyourself] = useState(
    getDataFromRedux?.aboutYourself ? getDataFromRedux?.aboutYourself : ""
  );
  const [credentials, setCredentials] = useState("");

  // Cover Photo States
  const coverRef = useRef(null);
  const [coverPhoto, setCoverPhoto] = useState(null);
  const [isEditingCover, setIsEditingCover] = useState(false);
  const [editedCoverPhoto, setEditedCoverPhoto] = useState(null);

  const [focusTags, setFocusTags] = useState(
    getDataFromRedux?.focusTags ? getDataFromRedux?.focusTags : []
  );

  const [levelsTaught, setLevelTaught] = useState(
    getDataFromRedux?.levelsTaught ? getDataFromRedux?.levelsTaught : []
  );

  const [teaches, setTeaches] = useState(
    getDataFromRedux?.teaches ? getDataFromRedux?.teaches : []
  );

  // Add Certficate States
  const certificateRef = useRef(null);
  const [certificateImg, setCertificateImg] = useState(null);
  const [certifications, setCertifications] = useState(null);
  const [certificates, setCertificates] = useState([]);

  const [expirationDate, setExpirationDate] = useState("");

  function addCoverPhoto() {
    coverRef.current.click();
  }
  function editCoverPhoto() {
    coverRef.current.click();
    setEditedCoverPhoto(null);
  }
  function deleteCoverPhoto() {
    setCoverPhoto(null);
    setEditedCoverPhoto(null);
  }

  function saveDataIntoRedux() {
    const res = {
      ...getDataFromRedux,
      fullName,
      aboutYourself,
      focusTags,
      levelsTaught,
      teaches,
      certificates,
      gender,
    };
    dispatch(setPersonalData("personal-info", res));
  }

  return (
    <div className={[classes.PersonalInfoScreen].join(" ")}>
      <Container fluid className={`p-0 ${classes.container}`}>
        <Row className={[classes.mb52, "g-0"].join(" ")}>
          <Col md={12}>
            <div className={`${classes.edit_heading_main_div}`}>
              <div>
                <h3
                  style={{
                    ...Fonts.h3,
                    color: Colors.neutralShadesOfNero,
                  }}
                >
                  Edit Profile
                </h3>
              </div>
              <div className={`${classes.edit_heading_button_div}`}>
                <Button
                  primary={false}
                  size="Medium"
                  customStyle={{
                    padding: "14px 19px",
                    width: "max-content",
                    marginRight: "12px",
                  }}
                >
                  Profile preview
                </Button>
                <Button
                  primary={true}
                  size="Medium"
                  customStyle={{
                    padding: "14px 19px",
                    width: "max-content",
                  }}
                  onClick={saveDataIntoRedux}
                >
                  Save changes
                </Button>
              </div>
            </div>
          </Col>
        </Row>
        <Row className={`g-0 ${classes.row}`}>
          <Col md={12} className={[classes.mb80].join(" ")}>
            {editedCoverPhoto !== null ? (
              <UploadedImageWithEditAndDelete
                image={editedCoverPhoto}
                editClick={() => editCoverPhoto()}
                deleteClick={() => deleteCoverPhoto()}
              />
            ) : (
              <Button
                customStyle={{
                  border: `1px dashed ${Colors.neutralShadesOfGainsboro}`,
                  height: "64px",
                  borderRadius: "10px",
                  width: "100%",
                  color: Colors.mainBlue,
                }}
                icon={AddImageIcon}
                size={"Medium"}
                onClick={addCoverPhoto}
                label={"Add cover photo"}
              />
            )}

            <input
              className="d-none"
              accept="image/*"
              type={"file"}
              ref={coverRef}
              onChange={(e) => {
                console.log("aaa");
                setCoverPhoto(e.target.files[0]);
                setIsEditingCover(true);
              }}
              onClick={(event) => {
                event.target.value = null;
              }}
            />
          </Col>

          <Col md={12} className={`${[classes.mb80].join(" ")}`}>
            <h5
              style={{ ...Fonts.h5, color: Colors.neutralShadesOfNero }}
              className={`${classes.mb32}`}
            >
              Your Gender
            </h5>
            <DropDown
              state={gender}
              setter={setGender}
              options={[
                { label: "Male", value: "Male" },
                { label: "Female", value: "Female" },
                { label: "Other", value: "Other" },
              ]}
            />
          </Col>

          <Col md={12}>
            <h5
              style={{ ...Fonts.h5, color: Colors.neutralShadesOfNero }}
              className={`${classes.mb32}`}
            >
              About You
            </h5>
          </Col>

          <Col md={12} className={`${classes.mb32}`}>
            <Input
              label="Full Name"
              state={fullName}
              setter={setFullName}
              placeholder=""
            />
          </Col>
          <Col md={12} className={`${classes.mb32}`}>
            <Input
              label="Phone Number (Optional)"
              state={phonenumber}
              setter={setPhonenumber}
              placeholder=""
            />
          </Col>
          <Col md={12} className={`${classes.mb32}`}>
            <Input
              type="date"
              label="Date Of Birth"
              state={dateOfBirth}
              setter={setDateOfBirth}
              placeholder=""
            />
          </Col>
          <Col md={12} className={`${classes.mb32}`}>
            <DropDown
              state={focusTags}
              options={[
                { value: "Forehand", label: "Forehand" },
                { value: "Backhand", label: "Backhand" },
                { value: "Volley", label: "Volley" },
                { value: "Serve", label: "Serve" },
                { value: "Slice", label: "Slice" },
                { value: "Mobility", label: "Mobility" },
              ]}
              setter={setFocusTags}
              isMulti={true}
              label="Focus tags (What part of the game can you improve your student??)"
            />
          </Col>

          <Col md={12} className={`${classes.mb32}`}>
            <DropDown
              state={levelsTaught}
              options={[
                { value: "Beginner", label: "Beginner" },
                { value: "Intermediate", label: "Intermediate" },
                { value: "Advanced", label: "Advanced" },
                { value: "Expert", label: "Expert" },
              ]}
              setter={setLevelTaught}
              isMulti={true}
              label="Levels taught"
            />
          </Col>

          <Col md={12} className={`${classes.mb32}`}>
            <DropDown
              state={teaches}
              options={[{ label: "Kids", value: "Kids" }]}
              setter={setTeaches}
              isMulti={true}
              label="Teaches"
            />
          </Col>

          {/* <Col md={12} className={`${classes.mb16}`}>
            <Row className={`g-0 ${classes.alignitemsend}`}>
              <Col md={8}>              
                  options={[
                    {
                      label: "Professional Tennis Registry",
                      value: "Professional Tennis Registry",
                    },
                  ]}
                  setter={setCertifications}
                  label="What certifications/licenses do you hold? (Optional)"
                />
              </Col>
              <Col md={3} style={{ padding: "0px 5px" }}>
                <Input
                  type="date"
                  placeholder=""
                  state={certificationDate}
                  setter={setCertificationDate}
                />
              </Col>
              <Col md={1}>
                <Button primary={false} icon={LinkIcon} />
              </Col>
            </Row>
          </Col> */}

          <Col md={12}>
            <div className={classes.certificationsInputs}>
              <div className="">
                <DropDown
                  label={"What certifications/licenses do you hold? (Optional)"}
                  state={certifications}
                  setter={setCertifications}
                  placeholder="Select Certificate"
                  options={[
                    { value: "ABC", label: "ABC" },
                    { value: "XYZ", label: "XYZ" },
                  ]}
                />
              </div>
              <div>
                <Input
                  placeholder={"Expiration Date"}
                  state={expirationDate}
                  setter={setExpirationDate}
                  inputStyle={{ height: "48px" }}
                />
              </div>
              <div>
                <Button
                  icon={LinkIcon}
                  customStyle={{
                    height: "48px",
                    width: "48px",
                    padding: "12px",
                  }}
                  onClick={() => {
                    certificateRef.current.click();
                  }}
                />
                {/* Hidden Input For Certificate Img */}
                <input
                  type={"file"}
                  ref={certificateRef}
                  className={"d-none"}
                  accept="image/png, image/jpeg, application/pdf"
                  onChange={(e) => setCertificateImg(e.target.files[0])}
                  onClick={(event) => {
                    event.target.value = null;
                  }}
                />
              </div>
            </div>
          </Col>

          {/* Render Certificates */}
          {certificates?.map((item) => {
            return (
              <Col md={12} key={item?._id}>
                <CertificateInformationCard
                  data={item}
                  onDelete={() => {
                    const newArr = [...certificates];
                    const index = newArr.findIndex((d) => d._id);
                    newArr.splice(index, index + 1);
                    setCertificates(newArr);
                  }}
                />
              </Col>
            );
          })}
          {/* Add Certficate */}
          <Col md={12} className={`${[classes.mb80, classes.mt24].join(" ")}`}>
            <LinkButtonWithIcon
              primary={true}
              text={"Add certificate"}
              leftIcon={AddIconBlue}
              disabled={
                certifications == null ||
                expirationDate == "" ||
                certificateImg == null
                  ? true
                  : false
              }
              onClick={() => {
                const newArr = [...certificates];
                newArr.push({
                  _id: Math.floor(Math.random() * 10000),
                  title: certifications?.label,
                  size: Math.ceil(certificateImg?.size / (1024 * 1024)),
                  date: expirationDate,
                  certificateImg: certificateImg,
                });
                setCertificates(newArr);
                setCertifications(null);
                setExpirationDate("");
                setCertificateImg(null);
              }}
            />
          </Col>

          <Col md={12} className={`${classes.mb80}`}>
            <h5
              style={{ ...Fonts.h5, color: Colors.neutralShadesOfNero }}
              className={`${classes.mb32}`}
            >
              About You
            </h5>
            <TextArea
              placeholder=""
              label="Tell a little about yourself. What makes you a great coach?"
              state={aboutYourself}
              setter={setAboutyourself}
            />
          </Col>

          <Col md={12} className={`${classes.mb32}`}>
            <h5
              style={{ ...Fonts.h5, color: Colors.neutralShadesOfNero }}
              className={`${classes.mb32}`}
            >
              Credentials and Experience
            </h5>
            <TextArea
              placeholder=""
              label="What is your area of expertise?"
              state={credentials}
              setter={setCredentials}
            />
          </Col>

          <Col md={12} className={`${classes.mb56}`}>
            <LinkButtonWithIcon
              customStyle={{
                ...Fonts.b2,
                fontSize: "14px",
                lineHeight: "20px",
              }}
              primary={true}
              text="Add more"
              leftIcon={AddIconBlue}
              disabled={true}
            />
          </Col>
        </Row>
      </Container>
      {/* Edit Photo Modal */}
      {isEditingCover && (
        <EditPhotoModal
          show={isEditingCover}
          setShow={setIsEditingCover}
          state={coverPhoto}
          onSave={setEditedCoverPhoto}
        />
      )}
    </div>
  );
};

export default function PersnalInfo() {
  const [isMobile, setIsMobile] = useState(false);
  useEffect(() => {
    isMobileViewHook(setIsMobile, 992);
  }, []);
  return isMobile ? <PersonalInfoMobile /> : <PersnalInfoDesktop />;
}
